/* eslint-disable no-console */

import {
  subscriptionBlockerType,
  subscriptionPlanTypes
} from '../constants/subscriptionConstants';
import useCompanyStore, {
  accessModule,
  countModule
} from '../store/companyStore/companyDetailsStore';
import usePlatformStore from '../store/platformStore/platformStore';

export const hasAccessToModule = (key: accessModule): boolean => {
  const {subscription} = useCompanyStore.getState();

  return subscription?.planRules?.[key]?.access;
};

export const hasMaxLimitReached = (key: countModule): boolean => {
  const {subscription, currentCount} = useCompanyStore.getState();
  const limit = subscription?.planRules?.[key]?.limit ?? null;

  return !(limit === null ? true : currentCount[key] < limit);
};

export const shouldBlockModuleAccess = (
  key1: accessModule,
  key2?: accessModule,
  key3?: accessModule
): boolean => {
  const {subscription} = useCompanyStore.getState();

  const rules = subscription?.planRules?.[key1];

  if (!rules) return true;

  let target: any = rules;
  if (key2) target = target[key2];
  if (key3) target = target?.[key3];

  if (!target) return true;

  return !(
    target?.access && target?.blockedType !== subscriptionBlockerType.FULL
  );
};

export const shouldBlockReportAccess = (reportName: any): boolean => {
  const {subscription} = useCompanyStore.getState();

  const hasAccessToModule =
    subscription?.planRules?.Reporting_And_ESG?.reportsAccess?.type?.some(
      (obj: any) => {
        return obj?.reportName === reportName && obj?.access;
      }
    );

  return !hasAccessToModule;
};

export const hasAccessToReport = (reportName: any): boolean => {
  const {subscription} = useCompanyStore.getState();

  return subscription?.planRules?.Reporting_And_ESG?.reportsAccess?.type?.some(
    (obj: any) => {
      return obj?.reportName === reportName;
    }
  );
};

export const getSubscriptionPlanType = (): string => {
  const {subscription} = useCompanyStore.getState();

  return subscription?.planType;
};

export const getModuleDataLimit = (key: accessModule): number => {
  const {subscription} = useCompanyStore.getState();
  const limit = subscription?.planRules?.[key]?.limit;

  return limit;
};

export const getAvailableDataLimit = (key: countModule): number => {
  const {subscription, currentCount} = useCompanyStore.getState();
  const limit = subscription?.planRules?.[key]?.limit ?? null;

  return limit === null ? limit : limit - currentCount[key];
};

export const isOnboardingDone = (): boolean => {
  const {isOnBoarded} = useCompanyStore.getState().companyDetails;
  if (!isOnBoarded) {
    usePlatformStore.getState().setOpenOnBoardingMessageModel(true);

    return false;
  }

  return true;
};

export const shouldBlockFreeOrTrial = (): boolean => {
  const planType = getSubscriptionPlanType();

  return (
    planType === subscriptionPlanTypes.FREE ||
    planType === subscriptionPlanTypes.FREE_TRIAL
  );
};

export const shouldBlockFree = (): boolean => {
  return getSubscriptionPlanType() === subscriptionPlanTypes.FREE;
};
